import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import './styles/tokens.css';
import './styles/base.css';
import { loadRuntimeConfig } from './config';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Élément racine introuvable.');
}

// Les réglages d'exécution sont lus AVANT que l'application ne soit importée : le client d'API et le
// fournisseur d'authentification les consultent au chargement de leur module, et un import statique
// les aurait évalués sur les valeurs du build, c'est-à-dire sur rien en cluster.
await loadRuntimeConfig();
const { App } = await import('./App');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
